
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Terminal } from "./Terminal";
import DeviceConfigurations from "./DeviceConfigurations";
import DeploymentHistory from "./DeploymentHistory";
import DeviceAuditLog from "./DeviceAuditLog";
import SystemInformation from "./SystemInformation";
import InstalledApplications from "./InstalledApplications";
import DeviceAnalytics from "./DeviceAnalytics";
import DeviceLogs from "./DeviceLogs";
import { type Device } from "@/hooks/useDevices";

interface DeviceTabsProps {
  device: Device;
  activeTab?: string;
  onTabChange?: (value: string) => void;
}

const DeviceTabs = ({
  device,
  activeTab = "info",
  onTabChange
}: DeviceTabsProps) => {
  return <div className="w-full bg-white dark:bg-slate-800 rounded-lg border">
      <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
        <TabsList className="w-full flex justify-between border-b bg-transparent mx-0 py-0 my-0 px-[16px]">
          <TabsTrigger value="info">System Information</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="apps">Applications</TabsTrigger>
          <TabsTrigger value="configs">Configurations</TabsTrigger>
          <TabsTrigger value="deployments">Deployments</TabsTrigger>
          <TabsTrigger value="terminal">Terminal</TabsTrigger>
          <TabsTrigger value="logs">Device Logs</TabsTrigger>
          <TabsTrigger value="audit">Audit Log</TabsTrigger>
        </TabsList>
        <div className="p-6 mx-0 px-[16px] py-[16px]">
          <TabsContent value="info">
            <SystemInformation device={device} />
          </TabsContent>
          <TabsContent value="analytics">
            <DeviceAnalytics device={device} />
          </TabsContent>
          <TabsContent value="apps">
            <InstalledApplications device={device} />
          </TabsContent>
          <TabsContent value="configs">
            <DeviceConfigurations deviceId={device.id} />
          </TabsContent>
          <TabsContent value="deployments">
            <DeploymentHistory deployments={device.script_deployments} />
          </TabsContent>
          <TabsContent value="terminal">
            <Terminal deviceId={device.id} />
          </TabsContent>
          <TabsContent value="logs">
            <DeviceLogs deviceId={device.id} />
          </TabsContent>
          <TabsContent value="audit">
            <DeviceAuditLog device={device} />
          </TabsContent>
        </div>
      </Tabs>
    </div>;
};

export default DeviceTabs;
